export default __webpack_public_path__ + "static/media/provider_3.313ef85b.png";